import styled from 'styled-components';

export const Wrapper = styled.div`
  color: var(--blue-60);
  text-transform: lowercase;
  strong {
    display: inline-block;
  }
  strong::first-letter {
    text-transform: uppercase;
  }
`;
